import type { PaginatedGiftCardStockDto } from "common/models/api/models/GiftCardStock";
import { apiClient } from "features/shared/api/axiosInstance";

export const giftcardsApiV2 = {
    getGiftCardStock: (params: { page: number; pageSize?: number; query?: string }) =>
        apiClient.get<PaginatedGiftCardStockDto>("/api/v2/local-giftcards/stock", { params }),
    loadGiftCardFileStock: (formData: FormData) =>
        apiClient.post("/api/v2/local-giftcards/file-stock", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        }),
    deleteGiftCardStock: (id: number) => apiClient.delete(`/api/v2/local-giftcards/stock/${id}`),
    exportGiftCardStock: (params: { partnerAddress: string }) =>
        apiClient.get<Blob>("/api/v2/local-giftcards/stock/export", {
            params,
            responseType: "blob",
        }),
};
